/**
* Content Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import ScrollMagic from 'ScrollMagic';
import animationGSAP from 'animation.gsap';
import addIndicators from 'debug.addIndicators';
import TweenMax from 'TweenMax';
import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {

    className: 'content-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // init controller
      const controller = new ScrollMagic.Controller();

      $( '.content-grid' ).each( function() {
        const lineTop = $( this ).find( '.line--top' )[0];
        const lineBottom = $( this ).find( '.line--bottom' )[0];
        const height = $( this ).outerHeight();

        if ( lineTop ) {
          // build scene
          const lineTopScene = new ScrollMagic.Scene( {
            triggerHook: .8, triggerElement: lineTop,
          } )
              .setClassToggle( lineTop, 'is-loaded' ) // trigger a TweenMax.to neonate
              // .addIndicators( {name: '1 (duration: 0)'} ) // add indicators (requires plugin)
              .addTo( controller );
        }

        if ( lineBottom ) {
          // build scene
          const lineBottomScene = new ScrollMagic.Scene( {
            triggerHook: .8, triggerElement: lineBottom,
          } )
              .setClassToggle( lineBottom, 'is-loaded' ) // trigger a TweenMax.to neonate
              // .addIndicators( {name: '1 (duration: 0)'} ) // add indicators (requires plugin)
              .addTo( controller );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-grid', COMPONENT );
} )( app );
